import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { UserService } from 'src/app/common/sharedServices/user/user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(private userService: UserService, private router: Router) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const actualUserData = await this.userService.getDatiUtente();
    if (!actualUserData) {
      console.debug('Users is NOT logged in and should not access this page');
      this.router.navigateByUrl('/login');
      return false;
    } else {
      return true;
    }
  }
}
